"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.historicalForexImpressionsList = void 0;
const React = require("react");
const md_1 = require("react-icons/md");
const si_1 = require("react-icons/si");
const general_impression_config_1 = require("../config/general-impression.config");
exports.historicalForexImpressionsList = [
    {
        id: 0,
        title: 'Resistência',
        subtitle: 'Atingida',
        description: 'A resistência de preço foi atingida, ou seja, seu preço máximo do período foi atingido, esta moeda demonstra dificuldade em quebras de resistência, tenha cuidado.',
        icon: React.createElement(md_1.MdMultilineChart, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 75,
        reportableIdentification: 'RESISTENCIA_ATINGIDA',
    },
    {
        id: 1,
        title: 'Suporte',
        subtitle: 'Atingido',
        description: 'Suporte de preço atingido, ou seja, o preço mais baixo do período foi atingido, esta moeda demonstra certa dificuldade em quebras de suporte, tenha cuidado.',
        icon: React.createElement(si_1.SiChartmogul, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 75,
        reportableIdentification: 'SUPORTE_ATINGIDO',
    },
    {
        id: 2,
        title: 'Boa chance',
        subtitle: 'De alta',
        description: 'Ao realizar análises avançadas da moeda em seus eventos, preços e gráficos, existe uma boa probabilidade que o preço continue a subir.',
        icon: React.createElement(md_1.MdShowChart, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.good,
        importantLevel: 85,
        reportableIdentification: 'BOA_CHANCE_ALTA',
    },
    {
        id: 3,
        title: 'Boa chance',
        subtitle: 'De baixa',
        description: 'Ao realizar análises avançadas da moeda em seus eventos, preços e gráficos, existe uma boa probabilidade que o preço continue a cair.',
        icon: React.createElement(md_1.MdStackedBarChart, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.warning,
        importantLevel: 85,
        reportableIdentification: 'BOA_CHANCE_BAIXA',
    },
    {
        id: 4,
        title: 'Perto',
        subtitle: 'Da resistência',
        description: 'Foi detectado que a resistência de preço está bem próxima de ser atingida, ou seja, está bem próxima do preço máximo, esta moeda demonstra certa dificuldade em quebra de resistência, tenha cuidado.',
        icon: React.createElement(md_1.MdOutlineMultilineChart, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 75,
        reportableIdentification: 'PERTO_RESISTENCIA',
    },
    {
        id: 5,
        title: 'Perto',
        subtitle: 'do suporte',
        description: 'Foi detectado que o suporte de preço está bem próximo de ser atingido, ou seja, está bem próximo do preço mínimo, esta moeda demonstra certa dificuldade em quebras de suporte, tenha cuidado.',
        icon: React.createElement(md_1.MdStackedBarChart, { size: general_impression_config_1.impressionConfig.size }),
        iconColor: general_impression_config_1.impressionConfig.colors.danger,
        importantLevel: 75,
        reportableIdentification: 'PERTO_SUPORTE',
    },
];
//# sourceMappingURL=historical-forex-impression.data.js.map